<div class="page-layout blank p-24" fusePerfectScrollbar>

    <h2>Welcome!</h2>

</div>
